(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-complementary-products"] && !window.DesignMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations-dynamic');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .then(e => {
        const complementaryProductsSwiper = new Swiper('.product-recommendations-dynamic .featured-products-slider', {
          slidesPerView: 4,
          spaceBetween: 6,
          allowTouchMove: false,
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 2,
              spaceBetween: 8
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 3,
              spaceBetween: 8
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 4,
              spaceBetween: 6
            }
          },
          navigation: {
            nextEl: '.product-recommendations-dynamic .swiper-box-arrow-next',
            prevEl: '.product-recommendations-dynamic .swiper-box-arrow-prev',
          }
        });
        new Swiper('.product-card-slider', {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          allowTouchMove: true,
          navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
          }
        });
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations-dynamic');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  if(productRecommendationsSection) observer.observe(productRecommendationsSection);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["you-may-also-like"] && !window.DesignMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .then(e => {
        const youMayAlsoLikeSwiper = new Swiper('.product-recommendations .featured-products-slider', {
          slidesPerView: 4,
          spaceBetween: 6,
          allowTouchMove: false,
          breakpoints: {
            // when window width is >= 320px
            320: {
              slidesPerView: 2,
              spaceBetween: 8
            },
            // when window width is >= 480px
            480: {
              slidesPerView: 3,
              spaceBetween: 8
            },
            // when window width is >= 768px
            768: {
              slidesPerView: 4,
              spaceBetween: 6
            }
          },
          navigation: {
            nextEl: '.product-recommendations .swiper-box-arrow-next',
            prevEl: '.product-recommendations .swiper-box-arrow-prev',
          }
        });
        new Swiper('.product-card-slider', {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          allowTouchMove: true,
          navigation: {
            nextEl: '.swiper-next',
            prevEl: '.swiper-prev',
          }
        });
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  if(productRecommendationsSection) observer.observe(productRecommendationsSection);


  } catch(e) { console.error(e); }
})();
})();
